import {Table,Space,Typography,Modal,Row,Col,Button, message,Input} from "antd"
import { useEffect, useState,useRef } from "react"
import InstituteService from "../../../services/InstituteService"
import { DeleteOutlined, EditOutlined, SnippetsOutlined,SearchOutlined } from "@ant-design/icons"
import { Link } from "react-router-dom"

const {Text,Title}=Typography;
export default function InstituteTable(params) {

    const [institutes,setInstitutes]=useState([])
    const [stateModal, setStateModal]=useState({visible:false});
    const [instituteTarget, setInstituteTarget] = useState({ title: "",id:0 });
    const [loadingTable, setLoadingTable] = useState(true);


    const searchInput = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    const getListInstitutes=async()=>{
        await InstituteService.getAllInstitutes().then((res=>{
            setInstitutes(res?.data?.response)
            setLoadingTable(false)
        })  
        );
    }
    useEffect(()=>{
        getListInstitutes()
    },[])

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };
  
    const handleReset = (clearFilters) => {
      clearFilters();
      setSearchText('');
    };

    const getColumnSearchProps = (dataIndex,title) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={`Buscar por ${title}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Buscar
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters)}
              size="small"
              style={{
                width: 90,
              }}
            >
              Reestablecer
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({
                  closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
              }}
            >
              Filtrar
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
            >
              Cerrar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? '#1677ff' : undefined,
          }}
        />
      ),
      onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      
    });


    const onAceptModal=async()=>{
      InstituteService.deleteInstituteById(instituteTarget.id).then((res)=>{
        if (res.data.success) {
          message.success("Eliminación del instituto exitosa")
          getListInstitutes()
        }else{
          message.error("Fallo la eliminación del instituto")
        }
      })
        hideModal()
    }

    const showModal = (record) => {
        setInstituteTarget({ title: record.name, id:record.id });
        setStateModal({
          visible: true,
        });
    };
      
    const hideModal = () => {
        setStateModal({
          visible: false,
        });
    };
      

    const columns=[
    {
        title:"Nombre",
        width:"15%",
        key:"name",
        fixed:"left",
        dataIndex: "name",
        ...getColumnSearchProps('name','nombre'),
        render:(text)=><Text  style={ {
          width: "100%" ,
        }
        }
        ellipsis={{
                tooltip: {text},
              }
        }>{text}</Text>
    },
    {
        title:"Siglas",
        key:"acronym",
        dataIndex:"acronym",
        ...getColumnSearchProps('acronym','sigla'),
    },
    {
        title:"Ubicación",
        key:"location",
        dataIndex:"location",
        render: (i,record)=>{
          const rowDataCampus=record?.Campus?.name;
          return <Text  style={ {
            width: "100%" ,
          }}
          ellipsis={{tooltip: {rowDataCampus}}}>
            {rowDataCampus}
          </Text>
        },
    },
    {
      title:"Coordinador",
      dataIndex:"coordinatorId",
      key:"coordinatorId",
      render: (i,record)=>{
        const rowDataCoo= record?.User?.firstName+' '+record?.User?.lastName;
        return <Text  style={ {
          width: "100%" ,
        }}
        ellipsis={{tooltip: {rowDataCoo}}}>
          {rowDataCoo}
        </Text>
      }
    },
    {
        title:"Opciones",
        width:"15%",
        dataIndex:"",
        key: "optionsForm",
        fixed: 'right',
        render:(_, record) => (
          <Space size="large" align='center'>
            <Link style={{display:"flex", flexDirection:"column"}} to={{pathname:"/institute/details/"+record.id,state:{instituteSelect:record}}}>
            <SnippetsOutlined>
            </SnippetsOutlined>
            <Text>Ver</Text>
            </Link>
            <Link style={{display:"flex", flexDirection:"column"}} to={"/institute/form/"+ record.id}>
              <EditOutlined> 
              </EditOutlined>
              <Text>Editar</Text>
            </Link >
            <Link style={{display:"flex", flexDirection:"column"}} onClick={()=>showModal(record)}>
              <DeleteOutlined>
              </DeleteOutlined>
              <Text>Eliminar</Text>
            </Link>
          </Space>
        ),
      },
]
    return(<>
    <Row align="center" style={{ marginTop: "25px" }}>
        <Col
          xs={{ span: 20 }}
          sm={{ span: 16 }}
          md={{ span: 16 }}
          lg={{ span: 16 }}
          xl={{ span: 16 }}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Title >Institutos</Title>
        </Col>
      </Row>
      <div className="">
        <Link to="/institute/form/">
          <Button
            type="primary"
            style={{
              marginRight:"4%",
              marginBottom: 16,
              float: "right",
            }}
          >
            Agregar Institutos
          </Button>
        </Link>
      </div>
        <Table
        rowKey={'id'}
        style={{ 
          marginLeft: "50px", 
          marginRight: "50px", 
          borderRadius:"3%",
        }}
        columns={columns}
        dataSource={institutes}
        loading={loadingTable}
        scroll={{
          x: 1300,
        }}
        >
        </Table>
        <Modal
        title={`Eliminar el centro '${instituteTarget.title}'`}
        open={stateModal.visible}
        onOk={onAceptModal}
        onCancel={hideModal}
        okText="Aceptar"
        cancelText="Cancelar"
        >
          <p>¿Esta seguro que desea eliminar el centro?</p>
        </Modal>
        </>
        
    )
}